import request from './request';

export default {
  findAvailablePhones: zipCode =>
    request.get(`/phone/find-available?zip=${zipCode}`),
  takePhone: phone => request.post('/phone/take', phone)
};
